/**
 * Image Element
 */

import type { ElementDefinition } from '@ai-content-hub/content-kit';
import { imageElementSchema, type ImageElementData } from './schema';
import {
    ImageEdit,
    type ImageEditConfig,
    type ImageEditHiddenField,
    type ImageEditProps,
} from './ImageEdit';
import { ImagePlayer } from './ImagePlayer';

export { imageElementSchema, type ImageElementData };
export { ImageEdit, type ImageEditProps, type ImageEditConfig, type ImageEditHiddenField };
export { ImagePlayer };
export {
    IMAGE_MAX_HEIGHT_VAR,
    DEFAULT_IMAGE_MAX_HEIGHT,
    SPLIT_COLUMN_IMAGE_MAX_HEIGHT,
    imageElementImgStyle,
    imageMaxHeightVars,
} from './imageStyle';

export const imageElement: ElementDefinition<ImageElementData, void> = {
    schema: imageElementSchema,
    EditComponent: ImageEdit as any,
    PlayerComponent: ImagePlayer as any,
};
